import { useReduxState } from 'hooks';
import { Avatar } from 'components/common';

interface Props {
  isExpanded: boolean;
  numberOfAdditionalItems: number;
  onClick: () => void;
}

const ProfileSummaryTimelineToggle = ({
  isExpanded,
  numberOfAdditionalItems,
  onClick
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="item">
      <div className="item-icon">
        <Avatar
          backgroundColor={theme.lightGrey}
          color={theme.textColor}
          icon={isExpanded ? 'chevron-up' : 'chevron-down'}
          fontSize="1.3rem"
          padding={isExpanded ? '5px 0' : '6px 0'}
          size="28px"
        />
      </div>
      <div className="item-content">
        <button className="item-button" onClick={onClick}>
          {isExpanded
            ? messages.commonShowLess
            : `${messages.commonShowMore} (${numberOfAdditionalItems})`}
        </button>
      </div>

      <style jsx>{`
        .item {
          display: flex;
          gap: 15px;
          margin-top: 30px;
          position: relative;
        }
        .item-content {
          flex-grow: 1;
        }
        .item-button {
          background-color: transparent;
          border: 0;
          color: ${theme.textColorLight};
          cursor: pointer;
          font-family: inherit;
          font-size: 1.6rem;
          font-weight: 600;
          margin-bottom: 5px;
          outline: 0;
          padding: 3px;
        }
        .item-button:focus,
        .item-button:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
};

export default ProfileSummaryTimelineToggle;
